/**
 * Money is handled in integer cents inside calculations and only converted back
 * to a decimal at the edges. Summing 0.1-style floats across a dozen line items
 * drifts by a cent or two, which is exactly the kind of thing a guest notices on
 * an invoice.
 */

export type Cents = number

export function toCents(amount: number): Cents {
  return Math.round(amount * 100)
}

export function fromCents(cents: Cents): number {
  return Math.round(cents) / 100
}

/** Commercial rounding of a cent amount after a multiplication. */
export function roundCents(value: number): Cents {
  return Math.round(value)
}

/** VAT on a net amount, given a percentage such as 10 or 20. */
export function vatOf(netCents: Cents, ratePercent: number): Cents {
  return roundCents(netCents * (ratePercent / 100))
}

/** Splits a gross amount into net and VAT (used when a price is quoted inclusive). */
export function splitGross(grossCents: Cents, ratePercent: number): { net: Cents; vat: Cents } {
  const net = roundCents(grossCents / (1 + ratePercent / 100))
  return { net, vat: grossCents - net }
}

export function sum(values: number[]): number {
  return values.reduce((a, b) => a + b, 0)
}
